import { render, staticRenderFns } from "./viewSalesOrder.vue?vue&type=template&id=27a00a3b&"
import script from "./viewSalesOrder.vue?vue&type=script&lang=js&"
export * from "./viewSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports